export const home ="/"
export const login ="/login"
export const signup ="/signup"
export const forgotpassword ="/forgotpassword"
export const resetpassword ="/resetpassword"
export const bankdetails ="/bankdetails"
export const gstdetails ="/gstdetails"
export const pickupaddress ="/pickupaddress"
export const supplierdetails ="/supplierdetails"
export const successful ="/successful"

// export const signup ="/signup"

export const ordermanagement ="/ordermanagement"
export const returnorder ="/returnorder"
export const inventory ="/inventory"
export const catalogsupload ="/catalogsupload"
export const newsboard ="/newsboard"
export const payment ="/payment"
export const settings ="/settings"
export const support ="/support"
export const addcatalog ="/addcatalog"
export const viewcatalog = "/viewcatalog"
export const viewmaincatalog = "/viewmaincatalog"



